"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18nWithNameSpace = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var i18nWithNameSpace = function i18nWithNameSpace(namespace) {
  return function (key) {
    return _I18n.default.text(namespace + "." + key);
  };
};

exports.i18nWithNameSpace = i18nWithNameSpace;